module.exports = __webpack_public_path__ + "img/library_article.45ed2967.svg";